import React from 'react';
import { Link } from 'react-router-dom';

// Previously there was no catch-all route, so an unmatched URL rendered a
// blank page (no <Routes> child matched, nothing was thrown, nothing shown).
const NotFound = () => (
  <div
    className="d-flex flex-column align-items-center justify-content-center text-center"
    style={{ minHeight: '100vh', padding: '2rem' }}
  >
    <h1 className="display-4">404</h1>
    <p className="text-muted">The page you're looking for doesn't exist.</p>
    <Link to="/" className="btn btn-primary mt-2">
      Go back home
    </Link>
  </div>
);

export default NotFound;
